export default __webpack_public_path__ + "static/nomika_hmedapis-6c73d86807a4db7d58b17710d230be6b.pdf";